function Island() {
  return (
    <div
      style={{
        position: "absolute",
        top: 11,
        left: "50%",
        transform: "translateX(-50%)",
        width: 80,
        height: 25,
        borderRadius: 13,
        background: "var(--color-kin-device-black)",
        zIndex: 50,
      }}
    />
  );
}

function StatusBar({ dark }) {
  const c = dark ? "var(--color-kin-device-light)" : "var(--color-kin-black)";
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "13px 22px 0",
        position: "relative",
        zIndex: 10,
        color: c,
      }}
    >
      <span
        style={{
          fontSize: 12,
          fontWeight: 700,
          fontFamily: "'Manrope', system-ui, -apple-system, sans-serif",
          letterSpacing: -0.3,
        }}
      >
        9:41
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
        <svg width="17" height="11" viewBox="0 0 17 11" fill={c}>
          <rect x="0" y="6.5" width="3" height="4.5" rx="0.8" />
          <rect x="4.7" y="4" width="3" height="7" rx="0.8" />
          <rect x="9.4" y="2" width="3" height="9" rx="0.8" />
          <rect x="14" y="0" width="3" height="11" rx="0.8" />
        </svg>
        <svg width="26" height="12" viewBox="0 0 26 12">
          <rect
            x="0.5"
            y="1"
            width="21"
            height="10"
            rx="2.5"
            stroke={c}
            strokeWidth="1.2"
            fill="none"
          />
          <rect x="2" y="2.5" width="17" height="7" rx="1.5" fill={c} />
          <path
            d="M22.5 4.5 Q24.5 4.5 24.5 6 Q24.5 7.5 22.5 7.5"
            stroke={c}
            strokeWidth="1.4"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
}

export function TabBar({ active, dark }) {
  const resolvedActive = active === "chat" ? "add" : active === "vault" ? "profile" : active;
  const activeColor = dark ? "var(--color-kin-device-active)" : "var(--color-kin-black)";
  const inactiveColor = dark ? "var(--color-kin-device-muted)" : "var(--color-kin-muted-soft)";
  const barBg = dark
    ? "color-mix(in srgb, var(--color-kin-device-black) 78%, transparent)"
    : "color-mix(in srgb, var(--color-kin-cream) 82%, transparent)";
  const barBorder = dark ? "rgba(255,255,255,0.16)" : "rgba(255,255,255,0.70)";
  const addActions = [
    {
      id: "file",
      label: "File",
      icon: (c) => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
          <path d="M12 16V6" strokeLinecap="round" />
          <path d="M8.5 9.5 12 6l3.5 3.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 17v1.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V17" />
        </svg>
      ),
    },
    {
      id: "note",
      label: "Note",
      icon: (c) => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
          <path d="M7 4h10a1.5 1.5 0 0 1 1.5 1.5v13L15 16H7a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 7 4z" />
          <path d="M9 9h6M9 12h4" strokeLinecap="round" />
        </svg>
      ),
    },
    {
      id: "voice",
      label: "Voice",
      icon: (c) => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
          <rect x="9" y="4.5" width="6" height="11" rx="3" />
          <path d="M6.5 11.5v1a5.5 5.5 0 0 0 11 0v-1M12 18v2.5" strokeLinecap="round" />
        </svg>
      ),
    },
    {
      id: "photo",
      label: "Photo",
      icon: (c) => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
          <rect x="3.5" y="6.5" width="17" height="12" rx="2" />
          <circle cx="12" cy="12.5" r="3.3" />
          <path d="M8.2 6.5 9.4 4.6h5.2l1.2 1.9" />
        </svg>
      ),
    },
    {
      id: "scan",
      label: "Scan",
      icon: (c) => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2">
          <path d="M7 4H5.5A1.5 1.5 0 0 0 4 5.5V7M17 4h1.5A1.5 1.5 0 0 1 20 5.5V7M20 17v1.5A1.5 1.5 0 0 1 18.5 20H17M7 20H5.5A1.5 1.5 0 0 1 4 18.5V17" />
          <path d="M8 12h8" strokeLinecap="round" />
        </svg>
      ),
    },
  ];

  const renderTab = (id, label, icon) => {
    const isActive = resolvedActive === id;
    const color = isActive ? activeColor : inactiveColor;
    return (
      <div
        key={id}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
          paddingBottom: 3,
        }}
      >
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "transparent",
            border: "1px solid transparent",
          }}
        >
          {icon(color)}
        </div>
        <span
          style={{
            fontSize: 9,
            fontWeight: 600,
            color,
            fontFamily: "'Manrope', system-ui, -apple-system, sans-serif",
            letterSpacing: "0.04em",
          }}
        >
          {label}
        </span>
        {isActive && (
          <div
            style={{
              width: 4,
              height: 4,
              borderRadius: 2,
              background: "var(--color-kin-gold-dark)",
              marginTop: -1,
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div style={{ position: "absolute", bottom: 10, left: 12, right: 12 }}>
      {resolvedActive === "add" && (
        <div
          style={{
            position: "absolute",
            right: 4,
            bottom: 78,
            zIndex: 22,
          }}
        >
          <div
            style={{
              position: "relative",
              width: 214,
            }}
          >
            <div
              style={{
                width: "100%",
                padding: "8px 8px 7px",
                background: "color-mix(in srgb, var(--color-kin-cream) 95%, transparent)",
                border: "1px solid rgba(255,255,255,0.80)",
                borderRadius: 17,
                backdropFilter: "blur(24px) saturate(150%)",
                boxShadow:
                  "0 4px 16px -4px rgba(0,0,0,0.04), 0 2px 4px -2px rgba(0,0,0,0.02), inset 0 1px 0 rgba(255,255,255,0.78)",
              }}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 2 }}>
                {addActions.map((action) => (
                  <div
                    key={action.id}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <div
                      style={{
                        width: 26,
                        height: 26,
                        borderRadius: 13,
                        background:
                          "color-mix(in srgb, var(--color-kin-muted-soft) 8%, transparent)",
                        border:
                          "1px solid color-mix(in srgb, var(--color-kin-muted-soft) 22%, transparent)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {action.icon("var(--color-kin-muted)")}
                    </div>
                    <span
                      style={{
                        fontSize: 6.3,
                        fontWeight: 700,
                        color: "var(--color-kin-body)",
                        fontFamily: "'Manrope', system-ui, -apple-system, sans-serif",
                        letterSpacing: "0.03em",
                      }}
                    >
                      {action.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                right: 20,
                bottom: -8,
                width: 20,
                height: 10,
                borderRadius: 8,
                background: "rgba(248,247,243,0.95)",
                border: "1px solid rgba(255,255,255,0.80)",
                borderTop: "none",
                boxShadow: "0 4px 12px -6px rgba(0,0,0,0.06)",
              }}
            />
          </div>
        </div>
      )}

      <div
        style={{
          background: barBg,
          backdropFilter: "blur(24px) saturate(130%)",
          border: `1px solid ${barBorder}`,
          borderRadius: 24,
          boxShadow:
            "0 4px 16px -4px rgba(0,0,0,0.06), 0 2px 4px -2px rgba(0,0,0,0.03), inset 0 1px 0 rgba(255,255,255,0.7)",
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr 1fr",
          alignItems: "end",
          gap: 0,
          padding: "8px 8px 8px",
        }}
      >
        {renderTab("home", "Home", (c) => (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.4">
            <path
              d="M5 10.5 12 5l7 5.5V19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M9.5 20v-5.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5V20" strokeLinecap="round" />
          </svg>
        ))}

        {renderTab("skills", "Skills", (c) => (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.4">
            <path
              d="M12 2l1.8 5.2h5.5l-4.4 3.2 1.7 5.2L12 12.4l-4.6 3.2 1.7-5.2-4.4-3.2h5.5z"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ))}

        {renderTab("profile", "Profile", (c) => (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.4">
            <circle cx="12" cy="8.5" r="3" />
            <path d="M5.5 19.5a7 7 0 0 1 13 0" strokeLinecap="round" />
          </svg>
        ))}

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: 12,
              background: "transparent",
              border: "1.5px solid rgba(180,170,158,0.35)",
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transform: "translateY(-4px)",
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={inactiveColor}>
              <path d="M12 6v12M6 12h12" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
          <span
            style={{
              fontSize: 9,
              fontWeight: 600,
              color: resolvedActive === "add" ? activeColor : inactiveColor,
              fontFamily: "'Manrope', system-ui, -apple-system, sans-serif",
              letterSpacing: "0.04em",
            }}
          >
            Add
          </span>
        </div>
      </div>
    </div>
  );
}

export function Phone({
  children,
  active = "home",
  dark = false,
  label = undefined,
  notes = [],
  scrollable = false,
  hideTabBar = false,
}) {
  const bg = dark
    ? "linear-gradient(170deg, #0A0A0C 0%, #0D1A10 100%)"
    : "radial-gradient(ellipse at 20% 15%, rgba(255,208,40,0.06) 0%, transparent 45%), radial-gradient(ellipse at 80% 85%, rgba(91,122,102,0.05) 0%, transparent 45%), linear-gradient(168deg, #F8F5EE 0%, #F5F3EC 35%, #F0F2EE 65%, #EEF2EB 100%)";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, width: 270, flexShrink: 0 }}>
      <div
        style={{
          position: "relative",
          width: 270,
          height: 570,
          borderRadius: 48,
          background: bg,
          boxShadow:
            "0 0 0 3.5px #1F2020, 0 30px 52px -18px rgba(18, 22, 19, 0.34), 0 6px 16px -8px rgba(20,24,20,0.22)",
          overflow: "hidden",
        }}
      >
        <Island />
        <StatusBar dark={dark} />
        <div
          className={scrollable ? "phone-scroll" : undefined}
          style={{
            position: "absolute",
            top: 48,
            left: 0,
            right: 0,
            bottom: hideTabBar ? 20 : 86,
            overflowY: scrollable ? "scroll" : "hidden",
            scrollbarWidth: "none",
          }}
        >
          {children}
        </div>
        {!hideTabBar && <TabBar active={active} dark={dark} />}
      </div>

      {(label || notes.length > 0) && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {label && (
            <p
              style={{
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: "0.22em",
                textTransform: "uppercase",
                color: "var(--color-kin-muted)",
                fontFamily: "'Manrope', system-ui, -apple-system, sans-serif",
              }}
            >
              {label}
            </p>
          )}
          {notes.map((note, i) => (
            <p
              key={i}
              style={{
                fontSize: 12.5,
                color: "var(--color-kin-muted)",
                lineHeight: 1.65,
                fontFamily: "'Manrope', system-ui, -apple-system, sans-serif",
              }}
            >
              — {note}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
